import styled from "styled-components";

export const MegaMenuTrigger = styled.li<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${props => props.isActive ? 'var(--primary)' : 'var(--neutral)'};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  padding: 20px 12px;
  cursor: pointer;
  transition: color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--primary);
    opacity: ${props => props.isActive ? 1 : 0};
    transition: opacity 0.2s ease;
  }

  &:hover {
    color: var(--primary);
    &::after {
      opacity: 1;
    }
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const MegaMenuPanel = styled.div`
  position: absolute;
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  min-width: 600px;
  max-width: 800px;
  top: 100%;
  right: 0;
  border: 1px solid var(--gray-light);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
`;

export const MegaMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MegaMenuItemTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--neutral);
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;

  &:hover {
    background: var(--gray-lightest);
    color: var(--primary);
  }
`;

export const MegaMenuSubItem = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: var(--neutral);
  padding: 6px 12px 6px 24px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s ease;

  &:hover {
    background: var(--gray-lightest);
    color: var(--primary);
  }
`;
